<app-admin-student-platform-header></app-admin-student-platform-header>

<div class="college-approval-page">
  <div class="page-header">
    <h1>College Management</h1>
    <p>Review, approve, and manage registered college institution accounts.</p>
  </div>

  <div class="filters-row">
    <input
      type="text"
      class="search-input"
      placeholder="Search by college name, contact name or email..."
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()"
    />
    <select class="status-select" [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()">
      <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
  </div>

  <div class="table-wrap">
    <table class="college-table">
      <thead>
        <tr>
          <th>College</th>
          <th>Location</th>
          <th>Contact</th>
          <th>Status</th>
          <th>Registered</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="6" class="empty-row">Loading colleges…</td>
        </tr>
        <tr *ngIf="!isLoading && colleges.length === 0">
          <td colspan="6" class="empty-row">No colleges found.</td>
        </tr>
        <tr *ngFor="let college of colleges">
          <td>
            <div class="college-name-cell" (click)="viewDetails(college.id)">
              <img *ngIf="college.college_logo_url" [src]="college.college_logo_url" class="college-logo" alt="" />
              <span>{{ college.college_name }}</span>
            </div>
          </td>
          <td>{{ college.city }}<span *ngIf="college.city && college.state">, </span>{{ college.state }}</td>
          <td>
            <div>{{ college.point_of_contact_name }}</div>
            <div class="muted">{{ college.point_of_contact_email }}</div>
          </td>
          <td><span class="badge" [ngClass]="statusBadgeClass(college.status)">{{ college.status }}</span></td>
          <td>{{ college.created_at | date: 'mediumDate' }}</td>
          <td class="actions-cell">
            <ng-container *ngIf="college.status !== 'approved'">
              <button class="btn-approve" [disabled]="isActionLoading" (click)="approve(college.id)">Approve</button>
            </ng-container>
            <button class="btn-reject" [disabled]="isActionLoading" (click)="openRejectModal(college.id)">Reject</button>
            <button class="btn-clarify" [disabled]="isActionLoading" (click)="openClarificationModal(college.id)">Clarify</button>
            <button class="btn-block" [disabled]="isActionLoading" (click)="toggleBlock(college)">
              {{ college.status === 'blocked' ? 'Unblock' : 'Block' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-row" *ngIf="totalPages > 1">
    <button [disabled]="page <= 1" (click)="goToPage(page - 1)">Prev</button>
    <span>Page {{ page }} of {{ totalPages }} ({{ total }} total)</span>
    <button [disabled]="page >= totalPages" (click)="goToPage(page + 1)">Next</button>
  </div>
</div>

<!-- Detail modal -->
<div class="modal-overlay" *ngIf="selectedCollege" (click)="closeDetails()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ selectedCollege.college_name }}</h2>
      <button class="close-btn" (click)="closeDetails()">&times;</button>
    </div>
    <div class="modal-body">
      <p><strong>Status:</strong> <span class="badge" [ngClass]="statusBadgeClass(selectedCollege.status)">{{ selectedCollege.status }}</span></p>
      <p><strong>Website:</strong> <a [href]="selectedCollege.college_url" target="_blank">{{ selectedCollege.college_url }}</a></p>
      <p><strong>University:</strong> {{ selectedCollege.university_name || '—' }}</p>
      <p><strong>Ranking:</strong> {{ selectedCollege.ranking || '—' }}</p>
      <p><strong>Location:</strong> {{ selectedCollege.city }}<span *ngIf="selectedCollege.city && selectedCollege.state">, </span>{{ selectedCollege.state }}, {{ selectedCollege.country }}</p>
      <p><strong>Streams:</strong> {{ selectedCollege.streams.join(', ') || '—' }}</p>
      <p><strong>Courses Offered:</strong> {{ selectedCollege.courses_offered.join(', ') || '—' }}</p>
      <p><strong>Placement Industries:</strong> {{ selectedCollege.placement_industries.join(', ') || '—' }}</p>
      <p><strong>Contact:</strong> {{ selectedCollege.point_of_contact_name }} ({{ selectedCollege.point_of_contact_email }}, {{ selectedCollege.phone_number }})</p>
      <p *ngIf="selectedCollege.rejection_reason"><strong>Rejection Reason:</strong> {{ selectedCollege.rejection_reason }}</p>
      <p *ngIf="selectedCollege.clarification_reason"><strong>Clarification Requested:</strong> {{ selectedCollege.clarification_reason }}</p>
    </div>
  </div>
</div>

<!-- Reject modal -->
<div class="modal-overlay" *ngIf="showRejectModal" (click)="showRejectModal = false">
  <div class="modal-box small" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Reject College Registration</h2>
      <button class="close-btn" (click)="showRejectModal = false">&times;</button>
    </div>
    <div class="modal-body">
      <label class="modal-label">Rejection Reason</label>
      <textarea class="modal-textarea" [(ngModel)]="rejectionReason" placeholder="Explain why this registration is being rejected..."></textarea>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" (click)="showRejectModal = false">Cancel</button>
      <button class="confirm-btn reject" [disabled]="isActionLoading" (click)="confirmReject()">Reject</button>
    </div>
  </div>
</div>

<!-- Clarification modal -->
<div class="modal-overlay" *ngIf="showClarificationModal" (click)="showClarificationModal = false">
  <div class="modal-box small" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Request Clarification</h2>
      <button class="close-btn" (click)="showClarificationModal = false">&times;</button>
    </div>
    <div class="modal-body">
      <label class="modal-label">What needs clarification?</label>
      <textarea class="modal-textarea" [(ngModel)]="clarificationReason" placeholder="Describe what additional information is needed..."></textarea>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" (click)="showClarificationModal = false">Cancel</button>
      <button class="confirm-btn clarify" [disabled]="isActionLoading" (click)="confirmClarification()">Send Request</button>
    </div>
  </div>
</div>
